import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { createDraft } from "../../data/onboardingApi";
import { CO_BASE, FIRST_CO_SLUG } from "../../domain/steps";
import { CoButton } from "../../components/Button";
import "../../styles.css";

/**
 * /admin/client-onboarding/new — creates the draft row, then hands off to its
 * first step. The id in the URL from that point on is the real public_id, so
 * the link survives a reload and can be shared.
 */
export function OnboardingNewPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | undefined>();
  // Guards against React 18 StrictMode double-invoking the effect and
  // creating two drafts.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    createDraft()
      .then((client) => {
        navigate(`${CO_BASE}/${client.public_id}/${client.current_step || FIRST_CO_SLUG}`, { replace: true });
      })
      .catch((cause: Error) => setError(cause.message));
  }, [navigate]);

  if (error) {
    return (
      <div className="co-root flex min-h-screen flex-col items-center justify-center gap-3 p-16 text-center">
        <h1 className="text-xl font-semibold tracking-tight">Couldn't start a new onboarding</h1>
        <p className="max-w-md text-sm text-muted-foreground">{error}</p>
        <CoButton variant="outline" onClick={() => navigate(CO_BASE)}>
          Back to client onboarding
        </CoButton>
      </div>
    );
  }

  return (
    <div className="co-root flex min-h-screen items-center justify-center p-16">
      <p className="text-sm text-muted-foreground">Starting a new onboarding…</p>
    </div>
  );
}
